/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from '../../ComponentLogger';
import TypeStrings from '../../TypeStrings';
import UpdateableComponentBase from './UpdateableComponentBase';
import UpdateableLabelComponent from './UpdateableLabelComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.requireComponent(UpdateableLabelComponent)
export default class UpdateableLabelPropertiesComponent extends UpdateableComponentBase<UpdateableLabelComponent, any>
{
    @property()
    protected propertyString: string = '';

    @property()
    protected notBoolean: boolean = false;

    protected component: UpdateableLabelComponent = null;

    protected onLoad(): void
    {
        this.component = this.node.getComponent(UpdateableLabelComponent);

        super.onLoad();
    }

    protected updateUI = (event?: cc.Event.EventCustom): void =>
    {
        let value: any = this.observable.Value;

        if (this.notBoolean && typeof(value) === TypeStrings.boolean)
        {
            value = !value;
        }

        try
        {
            this.component[this.propertyString] = value;
        }
        catch (error)
        {
            CLog.error(error, this, LogTypes.Initialization);
        }
    }
}
